import { jsx, Fragment } from "react/jsx-runtime";
import { ConciergePartItem } from "./ConciergePartItem.js";
function ConciergeMessagePart({
  parts,
  onProductClick,
  isStreaming,
  pdpStacklineSku,
  apiBaseUrl
}) {
  if (!parts || parts.length === 0) return null;
  const normalizedParts = parts;
  return /* @__PURE__ */ jsx(Fragment, { children: normalizedParts.map((part, index) => /* @__PURE__ */ jsx(
    ConciergePartItem,
    {
      part,
      allParts: normalizedParts,
      onProductClick,
      isStreaming,
      pdpStacklineSku,
      apiBaseUrl
    },
    `${part.type}-${index}`
  )) });
}
export {
  ConciergeMessagePart
};
//# sourceMappingURL=index.js.map
